import React, { useContext } from 'react'

import { ModalContextValue } from '../../types'

export const ModalContext = React.createContext<ModalContextValue>({
  modalPayload: null,
  showModal: () => {},
  hideModal: () => {}
})
const useModal = () => useContext(ModalContext)!

export default useModal
